
import { h } from "preact";
import Router, { RoutableProps } from "preact-router";
import { getLabels, Label } from "../../../api/product-api";
import { LabelFilesExplorer } from "../../../components/LabelFilesExplorer";
import { LabelPreview } from "../LabelPreview";
import { useCallback, useEffect, useMemo, useState } from "preact/hooks";
import { LabelFilesEditPage } from "./edit";
import { baseUrl, route } from "../../../App";
import { removeLabelFile } from "../../../api/label-creator";
import { useCommand, useRouteState } from "../../../hooks";
import { Snackbar, SnackbarShowCommand } from "../../../components/Snackbar";

import "./styles.scss";

export function LabelFilesPage(props: RoutableProps) {
    return <Router>
        <LabelFilesHomePage path={`${baseUrl}/label/files`}/>
        <LabelFilesEditPage path={`${baseUrl}/label/files/new`}/>
        <LabelFilesEditPage path={`${baseUrl}/label/files/edit`}/>
    </Router>
}


export function LabelFilesHomePage(props: RoutableProps & { successMessage?: string }) {
    const [label, setLabel] = useState(null as { path: string, metadata: { [key: string]: string } } | null)
    const [labels, setLabels] = useState([] as Label[]);
    const showSnackbarCommand = useCommand<SnackbarShowCommand>();
    const reloadExplorerCommand = useCommand();
    const [isPerformingLongAcion, setIsPerformingLongAction] = useState(false);
    const [labelPath, setLabelPath] = useRouteState("labelPath", "");

    useMemo(() => {
        getLabels().then(v => setLabels(v));
    }, []);

    if (!labels) {
        return <div style="display: flex; flex-direction: column; justify-content: center; align-items: center; width: 100%; height: 100%">
            <div>Pobieranie danych...</div>
            <div class="loader"></div>
        </div>;
    }

    const labelCanEdit = useMemo(() => {
        if (!label) {
            return false;
        }

        return !labels.find(v => v.path === label.path && v.type === "normal");
    }, [label, labels]);

    const labelCanRemove = useMemo(() => {
        if (!label) {
            return false;
        }

        return !labels.find(v => v.path === label.path);
    }, [label, labels]);

    useEffect(() => {
        if (!props.successMessage) {
            return;
        }

        showSnackbarCommand.run(props.successMessage, "success", "check", 4000);
        route("/label/files");
    }, [props.successMessage]);

    // if (!labels) {
    //     return <div style="display: flex; flex-direction: column; justify-content: center; align-items: center; width: 100%; height: 100%">
    //         <div>Pobieranie danych...</div>
    //         <div class="loader"></div>
    //     </div>;
    // }

    return <div class="label-files-page">
        <Snackbar doShow={showSnackbarCommand}/>
        <h1>Pliki naklejek</h1>
        <div style="display: flex">
            <div class="label-files paper">
                <h2>Eksplorator plików naklejek</h2>
                <div>
                    <LabelFilesExplorer height={400} onChange={(v) => setLabel(v)} path={labelPath ?? ""} onPathChange={setLabelPath} doReload={reloadExplorerCommand} />
                </div>
                <div class="label-files-actions">
                    <button onClick={() => route("/label/files/new?labelPath=" + encodeURIComponent(labelPath ?? ""))}>
                        <span style="font-size: 17px; margin-right: 5px;" class="icon">upload</span>
                        Dodaj nowy plik naklejki
                    </button>
                    {/* TODO: Handle change name */}
                    <span class="tooltip" data-tooltip="Funkcjonalność jeszcze niedostępna">
                        <button style="margin-left: 10px" class={"secondary " + (label ? "disabled" : "disabled")}>
                            <span style="font-size: 17px; margin-right: 5px;" class="icon">edit</span>
                            Zmień nazwę
                        </button>
                    </span>
                    <span class="tooltip tooltip-warning" {...(label && !labelCanEdit ? { "data-tooltip": "Nie można zmienić naklejki, ponieważ została ona użyta w naklejce produktu" } : {})}>
                        <button
                            style="margin-left: 10px"
                            class={"secondary " + (label && labelCanEdit ? "" : "disabled")}
                            onClick={() => route("/label/files/new?existingLabel=" + encodeURIComponent(label!.path))}
                        >
                            <span style="font-size: 17px; margin-right: 5px;" class="icon">loop</span>
                            Zamień plik naklejki
                        </button>
                    </span>
                    <span class="tooltip tooltip-warning" {...(label && !labelCanRemove ? { "data-tooltip": "Nie można usunąć naklejki, ponieważ została ona użyta w szablonie naklejki" } : {})}>
                        <button style="margin-left: 10px" class={"error " + (label && labelCanRemove ? "" : "disabled")} onClick={async () => {
                            try {
                                setIsPerformingLongAction(true);
                                await removeLabelFile(label!.path);
                                setIsPerformingLongAction(false);
                                showSnackbarCommand.run("Pomyślnie usunięto naklejkę", "success", "check", 2000);
                            }
                            catch(ex) {
                                console.error(ex);
                                showSnackbarCommand.run("Nie udało się usunąć naklejki", "error", "error", 2000);
                            }

                            reloadExplorerCommand.run();
                        }}>
                            <span style="font-size: 17px; margin-right: 5px;" class="icon">delete</span>
                            Usuń naklejkę
                        </button>
                    </span>
                </div>
            </div>
            <div class="label-files-right">
                <div class="label-preview paper">
                    <h2>Podgląd szablonu</h2>
                    <div class="preview-container">
                        <div class="preview">
                            {label ? <LabelPreview path={label.path} maxHeight={400} maxWidth={500} fonts={[
                                "https://fonts.googleapis.com/css?family=Roboto:300,400,500,700&display=swap"
                            ]}/> : null}
                        </div>
                    </div>
                </div>
                <div class="label-metadata paper">
                    <h2>Informacje o szablonie</h2>
                    <div class="template-info-table">
                        <div>Ścieżka</div>
                        <div>{label?.path}</div>
                    </div>
                </div>
            </div>
        </div>
        <div>
            <input type="checkbox" class="popup-visible" id="popup-visible-scan-paste" checked={isPerformingLongAcion}/>
            <div class="popup" style="z-index: 100">
                <label class="background"></label>
                <div class="content" style="display: flex; flex-direction: column; padding: 10px; width: 300px; height: 100px;">
                    <div style="display: flex; align-items: center;">
                        <div style="flex: 1 1 0; font-size: 14px">Usuwanie naklejki</div>
                    </div>
                    <div style="flex: 1 1 0; display: flex; justify-content: center; align-items: center;">
                        <div class="loader"/>
                    </div>
                </div>
            </div>
        </div>
    </div>;
}
